import { render, staticRenderFns } from "./SearchCriteriaBuilderModal.vue?vue&type=template&id=5486e296&"
import script from "./SearchCriteriaBuilderModal.vue?vue&type=script&lang=js&"
export * from "./SearchCriteriaBuilderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports